import type { FetchResult } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { BannerPropertyName } from '@xingternal/crate-common-graphql-types';

import { mapBadges } from './map-badges';
import type { CommunicationMarkNotificationBadgesAsSeenMutation } from './mark-notification-badges-as-seen.gql-types';
import { CommunicationMarkNotificationBadgesAsSeenDocument } from './mark-notification-badges-as-seen.gql-types';
import { BannerPropertyDisableDocument } from './zerofy-new-badge.gql-types';

export type UseZerofyNotificationBadges = {
  markBadgesAsSeen: (
    badges: Array<string>
  ) => Promise<FetchResult<CommunicationMarkNotificationBadgesAsSeenMutation>>;
};

export const useZerofyNotificationBadges = (): UseZerofyNotificationBadges => {
  const [markAsSeen] = useMutation(
    CommunicationMarkNotificationBadgesAsSeenDocument
  );

  const [markBannerAsSeen] = useMutation(BannerPropertyDisableDocument);

  const markBadgesAsSeen = useCallback(
    (badges: string[]) => {
      if (badges.indexOf('insights') !== -1) {
        markBannerAsSeen({
          variables: {
            input: { propertyName: BannerPropertyName.DisplayInsightsBanner },
          },
        });
      }
      return markAsSeen({
        variables: { badges: { badgeNames: mapBadges(badges) } },
      });
    },
    [markAsSeen, markBannerAsSeen]
  );

  return { markBadgesAsSeen };
};
